<template>
    <div class="select-reference-container">
      <label class="control-label">Mês de Referência</label>
      <Select
        v-model="reference"
        :showOptionEmpty="false"
        :options="references"
        @input="update"
      />
    </div>
  </template>
  
  <script>
  import Select from '@/components/common/Select'  
  export default {
    components: {
      Select
    },
    props: {
      value: {
        type: String
      }
    },
    created() {
      this.generateReferences()
      if (this.value.length === 6) this.reference = this.value
    },
    data() {
      return {
        references: [],
        reference: null,
      }
    },
    watch: {
      reference(value) {
        if (value) this.update()
      }
    },
    methods: {
      update() {
        this.$emit('input', this.reference)
      },
      generateReferences() {
        const currentYear = new Date().getFullYear()
        const currentMonth = new Date().getMonth();
        const labelOptions = { month: 'long', year: 'numeric' }
        const valueOptions = { month: '2-digit' }

        this.references.push({ label:"Selecione o mês de referência", value: null })
  
        for (let index = 0; index < 12; index++) {
          const date = new Date(currentYear, index, 1)
          const label = date.toLocaleString('pt-br', labelOptions)
          const value = `${currentYear}${date.toLocaleString('pt-BR', valueOptions )}`
  
          this.references.push({ label, value })
        }
  
        if (currentMonth === 11) {
          const nextYear = currentYear + 1;
          const date = new Date(nextYear, 0, 1)
          const label = date.toLocaleString('pt-br', labelOptions)
          const value = `${nextYear}${date.toLocaleString('pt-BR', valueOptions )}`
  
          this.references.push({ label, value })
        }
      }
    }
  }
  </script>
  
  <style scoped>
  .select-reference-container {
    display: block;
    font-size: 14px;
    font-weight: 600;
    color: #1a202c;
    font-family: BlinkMacSystemFont, -apple-system, Segoe UI, Roboto, Oxygen,
      Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, Helvetica, Arial,
      sans-serif;
    -webkit-font-smoothing: antialiased;
    margin-bottom: 5px;
  }
  
  .select-reference-container select {
    text-transform: uppercase;
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/Escala/SelectReferencia.vue